import React from 'react';
import { useNavigate } from 'react-router';
import { ArrowLeft } from 'lucide-react';
// import { useTranslation } from 'react-i18next';

export default function BackPageButton() {
  const navigate = useNavigate();

  return (
    <button className="border rounded-sm p-8 bg-grey-white hover:bg-grey-100" onClick={() => navigate(-1)}>
      <ArrowLeft className="w-8 h-8" />
    </button>
  );
}
